module.exports = __webpack_public_path__ + "static/media/flexible-image-1.bbdecc8f.jpg";